// extracted by mini-css-extract-plugin
module.exports = {"value__container":"ReportingValue_value__container__eu1DP","icon":"ReportingValue_icon__3fzMo","text":"ReportingValue_text__2kJod"};